/* Shopify chat deep link — `?chat` opens the Shopify chat panel.

   The legacy Shopify Inbox widget opened itself when the URL carried `?chat`; the
   current <shopify-chat> web component (cdn.shopify.com/storefront/web-components/
   chat.js, injected by the Shopify Inbox app embed) does not, so links such as the
   contact page's "Chat with us" button (…/pages/contact-us?chat) stopped working.
   This restores that contract through the component's public show() method:
   - page loads with `?chat`            -> open the panel
   - click on a `?chat` link to THIS page -> open the panel without a reload
   Links to other pages navigate normally and open on arrival.

   No-op when the chat app embed is disabled (no <shopify-chat> on the page). */
(function () {
  "use strict";

  var PARAM = "chat";
  var TAG = "shopify-chat";

  function chatElement() {
    return document.querySelector(TAG);
  }

  function openChat() {
    if (!chatElement() || !window.customElements) return;
    window.customElements.whenDefined(TAG).then(function () {
      var chat = chatElement();
      if (chat && typeof chat.show === "function" && !chat.open) chat.show();
    });
  }

  function hostKey(host) {
    return host.replace(/^www\./, "");
  }

  function pathKey(path) {
    return path.replace(/\/+$/, "") || "/";
  }

  // A `?chat` link whose target is the page we're already on (www/apex and a
  // trailing slash are treated as the same page).
  function isChatLinkToThisPage(link) {
    var url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (e) {
      return false;
    }
    return (
      url.searchParams.has(PARAM) &&
      hostKey(url.hostname) === hostKey(window.location.hostname) &&
      pathKey(url.pathname) === pathKey(window.location.pathname)
    );
  }

  document.addEventListener("click", function (event) {
    var link = event.target.closest && event.target.closest("a[href]");
    if (!link || !chatElement() || !isChatLinkToThisPage(link)) return;
    event.preventDefault();
    openChat();
  });

  if (new URLSearchParams(window.location.search).has(PARAM)) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", openChat);
    } else {
      openChat();
    }
  }
})();
